import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { DocumentsUploadProcessItemFragment } from 'generated/resources/graphql'

import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import { useManualDocumentAssignerContext } from 'modules/documents/components/BulkFiles/ManualDocumentAssigner/context'

interface Props {
  uploadProcess: DocumentsUploadProcessItemFragment
  onDistribute: () => void
}

const AssignerFooter = ({ uploadProcess, onDistribute }: Props) => {
  const context = useManualDocumentAssignerContext()

  const canDistribute = useMemo(() => {
    return context.payslipsNotAssigned == 0
  }, [context.payslipsNotAssigned])

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      paddingY="s12"
      paddingX="s16"
      background="grey200"
      justifyContent="spaceBetween"
    >
      <Box flexDirection="row" gap="s8">
        {!canDistribute && (
          <Text size="200">
            {i18n.t('split_documents.workflow_payslips.footer.info', {
              count: context.payslipsNotAssigned,
            })}
          </Text>
        )}
      </Box>
      <Box flexDirection="row">
        <Box paddingLeft="s8">
          <Box flexDirection="row" gap="s8">
            <Button
              type="primary"
              disabled={!uploadProcess || !canDistribute}
              onClick={onDistribute}
            >
              {i18n.t('split_documents.workflow_payslips.footer.distribute')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default AssignerFooter
